import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from "@angular/core"
import { FormGroup } from "@angular/forms"
import { AgColor, AgSecondaryColor } from "@shared/components/ag-label/ag-label.component"
import { IconImageService } from "@shared/services/icon-image.service"
@Component({
  selector: "ag-drop-down",
  templateUrl: "./ag-drop-down.component.html",
  styleUrls: ["./ag-drop-down.component.scss"],
  standalone: false,
})
export class AgDropDownComponent implements OnInit, AfterViewChecked {
  //data
  @Input() list: LabelValue[] = [] //if you want to have categories in your drop-down insert an item in the list with value of 'search-box-title'
  @Input() currentValue: LabelValue
  @Input() currentValueMultiple: LabelValue[] = []

  //Layout
  @Input() useFixedPosition = false
  @Input() showSearchField = true
  @Input() showSelectAll = true //only for multiple
  @Input() multipleOutput = false //need to be set to true when you use currentValueMultiple
  @Input() hasIcons: boolean = false
  @Input() noIconText: boolean = false
  @Input() error: boolean = false
  @Input() dropDownTitle = "" //remember to give '' if you don't want a title
  @Input() hint = "" //This can only be used if you don't use currentValue or currentValueMultiple
  @Input() infoMessage: string
  @Input() errorMessage: string
  @Input() staticIcon = "" //Used when u need to show icon in the dropdown just icon
  @Input() type: AgType = "text-single"
  @Input() disabledInputs: LabelValue[] = [] //Used in the multiple section, for disabling inputs
  @Input() hintForDisabledInputs: string = "" //Used in the multiple section, for displaying hints next to disabled inputs
  @Input() numberInSection: number[] = [2, 2, 2, 2, 2] //Used to determine section size in multiple section
  @Input() chooseMultipleCheckmark: boolean = true
  @Input() checkboxType: checkboxType = "none"
  @Input() textIcon: boolean = false
  @Input() subLabelColor: AgColor = "Info" //Used for ag-single-sublabel-box
  @Input() subLabelSecondaryColor: AgSecondaryColor = "Standard" //Used for ag-single-sublabel-box

  //css
  @Input() size: AgSize = "small"
  @Input() disable = false
  @Input() backgroundColor = ""
  @Input() maxHeight: number = 259 // Set to what is needed plus 43
  @Input() specificHeight: number = 0
  @Input() minWidth: number
  @Input() maxWidth: number
  @Input() maxHeightNotClicked: number = 0
  @Input() dropDownWidth?: number
  @Input() withHoverEffect: boolean = false

  @Output() changedValue = new EventEmitter<LabelValue>()
  @Output() changedValueMultiple = new EventEmitter<LabelValue[]>()
  @Output() dropdownClosed = new EventEmitter<boolean>()
  @Output() dropdownOpened = new EventEmitter<boolean>()

  @ViewChild("dropDownContainer") dropDownContainer: ElementRef
  @ViewChild("dropDownList") dropDownList: ElementRef
  @ViewChild("searchBoxWrapper") searchBoxWrapper: ElementRef<HTMLElement>
  public currentCurrency = 0
  public dropDownDirection = "down"
  public currencyForm: FormGroup
  public hideSearchBox = true
  public sizeOffset = "52px"

  @HostListener("document:click", ["$event"])
  clickedOutside(event) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.hideSearchBox) {
      this.hideSearchBox = true
      this.dropdownClosed.emit(true)
    }
  }

  constructor(
    private eRef: ElementRef,
    private renderer: Renderer2,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    if (this.dropDownTitle || this.type === "country-code") {
      this.size = "large"
    }
  }
  ngAfterViewChecked() {
    if (!this.hideSearchBox) {
      var dropDownListHeight = this.searchBoxWrapper?.nativeElement.offsetHeight ?? 0
      var dropDownContainer = this.dropDownContainer?.nativeElement?.getBoundingClientRect().top
      var windowHeight = window.innerHeight
      if (windowHeight - dropDownContainer < dropDownListHeight + 48) {
        this.dropDownDirection = "up"
        this.sizeOffset = this.size === "small" ? "52px" : "60px"
      } else {
        this.dropDownDirection = "down"
      }
    }
  }

  public showHint(): boolean {
    if (!this.isLabelValueEmpty(this.currentValue) && this.currentValueMultiple.length === 0) {
      return false
    }
    if (this.isLabelValueEmpty(this.currentValue) && this.currentValueMultiple.length > 0) {
      return false
    }
    if (this.staticIcon) {
      return false
    }
    return true
  }
  public isLabelValueEmpty(object: LabelValue | null): boolean {
    return !object || (!object.label && !object.value)
  }

  public onOutput(value: LabelValue): void {
    this.currentValue = value
    this.changedValue.emit(value)
    this.hideSearchBox = true
  }
  public unSectionOutput(value: LabelValue[]): void {
    this.changedValueMultiple.emit(value)
  }

  public onOutputMultiple(value: LabelValue[]): void {
    this.currentValueMultiple = value
    this.changedValueMultiple.emit(value)
    this.multipleOutput = true
  }

  public onSearchBoxFieldClicked(value: boolean): void {
    this.onFieldClicked()
  }

  public onFieldClicked(): void {
    if (!this.disable) {
      this.hideSearchBox = !this.hideSearchBox
      if (this.hideSearchBox) {
        this.dropdownClosed.emit(true)
      } else {
        this.dropdownOpened.emit(true)
      }
    }
  }

  public checkIfIconText(): boolean {
    if (this.multipleOutput === false && this.hasIcons && this.currentValue && this.staticIcon === "" && this.textIcon) {
      return true
    }
  }
  public checkIfSingleValue(): boolean {
    return this.multipleOutput === false && this.currentValue && this.staticIcon === "" && !this.textIcon
  }
}

export interface LabelValue {
  label: string
  value: any
  subLabel?: string
}
export type AgSize = "small" | "large"
export type checkboxType = "square" | "circle" | "none"
export type AgType = "text-single" | "text-multiple" | "country-code" | "right-checkMark" | "text-multiple-section" | "icon-text" | "checkbox" | "text-single-sublabel" | "text-single-description"
